// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 538 ? "recorder" : chunkId) + "-legacy." + {"538":"d3555b05","726":"9daac29a"}[chunkId] + ".js";
};